export default {"src":"/_next/static/media/transactionHistory.069ca587.svg","height":28,"width":28};